import Vue from "vue";
import VueRouter from "vue-router";
import { createProvider } from "./vue-apollo";
import { InMemoryCache } from "apollo-cache-inmemory";

import App from "./App.vue";

// import About from "./screens/About.vue";
// import Main from "./screens/Main.vue";

Vue.use(VueRouter);

Vue.config.productionTip = true;

// const router = new VueRouter({
//   mode: "history",
//   base: __dirname,
//   routes: [
//     // { path: "/about", component: About },
//     // { path: "/test", component: App },
//     // { path: "/main", component: Main }
//   ]
// });

new Vue({
  el: "#app",
  // router,
  apolloProvider: createProvider({
    cache: new InMemoryCache()
  }),
  sapollo: {},
  render: h => h(App)
});
